<template>
    <div>
        <!-- Show when Customer Record not exists -->
        <not-found
            v-if="!Object.keys(customerDetails).length && !showPageLoader"
        ></not-found>
        <!-- Show when Customer Record not exists -->

        <!-- When data is loading -->
        <base-table-spinner
            v-if="!Object.keys(customerDetails).length && showPageLoader"
        ></base-table-spinner>
        <!-- When data is loading -->

        <div
            v-if="Object.keys(customerDetails).length"
            class="card customer-info screen-section"
            :class="{ freeze: isActive }"
        >
            <button
                class="close freezeBUtton"
                type="button"
                @click="isActive = !isActive"
            >
                <span v-if="!isActive" class="btn-text">Freeze Section</span>
                <span v-if="isActive" class="btn-text"
                    ><i class="icon-caret-down"></i
                ></span>
            </button>
            <customer-information
                :customer-details="customerDetails"
            ></customer-information>
        </div>

        <div
            v-if="Object.keys(customerDetails).length"
            class="filter-section sub-filter"
            :class="{ freezedActive: isActive }"
        >
            <div class="row">
                <div class="col-md-5 filter-title-section font-sm">
                    <h2>Name Screening Hit Details</h2>
                </div>

                <div class="col-md-3 mt-custom-44">
                    <button
                        :class="[
                            'btn btn-primary',
                            { disabled: loading },
                            {
                                'button-disabled': isBtnDisabled,
                            },
                        ]"
                        type="button"
                        @click="updatedNameScreeningDetails()"
                    >
                        <span class="btn-text">Update Name screening</span>
                        <span class="loader"></span>
                    </button>
                </div>
                <div class="col-md-3 mt-custom-44">
                    <button
                        :class="[
                            'btn btn-primary',
                            { disabled: loadingSummaryPdf },
                        ]"
                        type="button"
                        @click="startDownload()"
                    >
                        <span class="btn-text">Download Summary Report</span>
                        <span class="loader"></span>
                    </button>
                </div>
                <div class="col-md-1 mt-custom-44">
                    <i
                        v-b-tooltip.hover.html="tipMethod"
                        class="icon-error_outline info-tooltip"
                    ></i>
                </div>
            </div>

            <div class="row">
                <div class="col-md-5"></div>
                <div class="col-md-3">
                    <b-form-checkbox
                        v-model="markHits"
                        name="check-button"
                        switch
                        @change="toggleAllHitsAsNotGenuine(markStatus, $event)"
                        value="true"
                        unchecked-value="false"
                        :disabled="isBtnDisabled"
                    >
                        <b>Mark ALL as not Genuine</b>
                    </b-form-checkbox>
                </div>
                <div class="col-md-3">
                    <b-form-checkbox
                        v-model="checked"
                        name="check-button"
                        switch
                        @change="toggleHideInactiveHits()"
                    >
                        <b>Hide Inactive Hits</b>
                    </b-form-checkbox>
                </div>
            </div>
        </div>
        <div v-if="Object.keys(customerDetails).length">
            <div
                class="table-section table-min-width"
                :class="{
                    'overflow-hidden': !items.length && !showPageLoader,
                }"
            >
                <b-table :items="items" :fields="fields">
                    <!-- <template slot="full_name" slot-scope="data">
                        <a
                            href="javascript:void(0);"
                            tabindex="-1"
                            class="cursor-pointer"
                            @click="
                                selectedRecord(data.item.screeningData)
                                $bvModal.show('screening-detail-popup')
                            "
                            >{{ data.item.screeningData.name | primaryName }}</a
                        >
                    </template> -->
                    <template slot="full_name" slot-scope="data">
                        <a
                            href="javascript:void(0);"
                            class="cursor-pointer"
                            @click="
                                $router.push({
                                    name: 'screening-hit-detail',
                                    params: {
                                        id: id,
                                        hitId: data.item._id,
                                    },
                                })
                            "
                            >{{
                                checkNameType(data.item.screeningData.name)
                            }}</a
                        >
                    </template>
                    <!-- <template slot="father" slot-scope="data">
                        {{ data.item.screeningData.name | fathersName }}
                    </template> -->
                    <template slot="dates" slot-scope="data">
                        {{ getMatchedDob(data.item.screeningData) }}
                    </template>
                    <template slot="fathersName" slot-scope="data">
                        {{ data.item.screeningData.fathersName | simpleReturn }}
                    </template>
                    <template slot="identificationType" slot-scope="data">
                        {{
                            getMatchedIdNumber(
                                data.item.screeningData.identificationType
                            )
                        }}
                    </template>
                    <template slot="country" slot-scope="data">
                        {{ getMatchedCountry(data.item.screeningData) }}
                    </template>
                    <!-- <template slot="sourceReferenceId" slot-scope="data">
                        {{ descriptionFormatting(data.item.screeningData) }}
                    </template> -->
                    <template slot="publisherName" slot-scope="data">
                        {{ getPublisherName(data.item.screeningData) }}
                    </template>
                    <template slot="sourceList" slot-scope="data">
                        {{ getSourceName(data.item.screeningData) }}
                    </template>
                    <template slot="score" slot-scope="data">
                        <!-- <status-type-icon
                            :status-type="data.item.score"
                        ></status-type-icon> -->
                        <span
                            :class="
                                objectIsEmpty(data.item.scoreObject)
                                    ? ''
                                    : 'scoreBreakdownLink'
                            "
                            @click="showScoreBreakDown(data.item)"
                        >
                            {{ data.item.score ? data.item.score : 'N/A' }}
                        </span>
                    </template>
                    <template slot="sanction" slot-scope="data">
                        <status-type-icon
                            :status-type="
                                data.item.screeningData.listCategory ==
                                    'Adverse Media' &&
                                data.item.screeningData.sourceList ==
                                    'Smart Search'
                                    ? 'false'
                                    : data.item.sanction
                            "
                            class="cursor-pointer"
                        ></status-type-icon>
                    </template>
                    <template slot="rep" slot-scope="data">
                        <status-type-icon
                            :status-type="
                                data.item.screeningData.listCategory ==
                                    'Adverse Media' &&
                                data.item.screeningData.sourceList ==
                                    'Smart Search'
                                    ? 'false'
                                    : data.item.pep
                            "
                        ></status-type-icon>
                    </template>
                    <template slot="enforcement" slot-scope="data">
                        <status-type-icon
                            :status-type="
                                data.item.screeningData.listCategory ==
                                    'Adverse Media' &&
                                data.item.screeningData.sourceList ==
                                    'Smart Search'
                                    ? 'false'
                                    : data.item.enforcement
                            "
                        ></status-type-icon>
                    </template>
                    <template slot="adverseMedia" slot-scope="data">
                        <status-type-icon
                            :status-type="
                                data.item.screeningData.listCategory ==
                                    'Adverse Media' &&
                                data.item.screeningData.sourceList ==
                                    'Smart Search'
                                    ? 'high'
                                    : 'false'
                            "
                        ></status-type-icon>
                    </template>

                    <!-- <template slot="blackList" slot-scope="data">
                        <status-type-icon
                            :status-type="data.item.blackList"
                        ></status-type-icon>
                    </template> -->
                    <template slot="hit" slot-scope="data">
                        <base-status
                            :status-type="
                                data.item.hitDetermination == 'pending'
                                    ? 'potential'
                                    : data.item.hitDetermination
                            "
                        ></base-status>
                    </template>

                    <template slot="genuine" slot-scope="data">
                        <b-form-radio
                            :disabled="isBtnDisabled"
                            v-model="
                                updatedDetails[data.index].hitDetermination
                            "
                            value="hit"
                            :name="updatedDetails[data.index]._id"
                            @change="
                                updateNameScreeningHits(
                                    $event,
                                    updatedDetails[data.index]._id
                                )
                            "
                        ></b-form-radio>
                    </template>
                    <template slot="not-genuine" slot-scope="data">
                        <b-form-radio
                            :disabled="isBtnDisabled"
                            v-model="
                                updatedDetails[data.index].hitDetermination
                            "
                            :name="updatedDetails[data.index]._id"
                            value=""
                            @change="
                                updateNameScreeningHits(
                                    $event,
                                    updatedDetails[data.index]._id
                                )
                            "
                        ></b-form-radio>
                    </template>
                    <template slot="comments" slot-scope="data">
                        <b-form-textarea
                            id="textarea"
                            v-model="updatedDetails[data.index].comments"
                            placeholder="Enter your comments..."
                            rows="1"
                            max-rows="6"
                            :disabled="isBtnDisabled"
                        ></b-form-textarea>
                    </template>
                </b-table>
                <!-- When items is loading -->
                <base-table-spinner
                    v-if="!items.length && showPageLoader"
                ></base-table-spinner>
                <!-- When record not found -->
                <base-no-screening-hit
                    v-if="!items.length && !showPageLoader"
                ></base-no-screening-hit>
            </div>
        </div>

        <!-- <div
            v-if="Object.keys(customerDetails).length"
            class="filter-section sub-filter d-none-print"
        >
            <h2>Adverse Media Search</h2>
            <div class="card iframe-section">
                <div id="style-2" class="scrollable"> -->
        <!-- google search -->
        <!-- <iframe :src="searchUrl"></iframe> -->
        <!-- google search end-->
        <!-- </div>
            </div>
        </div> -->

        <cancel-review-process-popup></cancel-review-process-popup>
        <kyc-status-review-popup></kyc-status-review-popup>
        <screening-detail-popup></screening-detail-popup>
        <manual-alert-popup></manual-alert-popup>
        <otp-verification-popup></otp-verification-popup>
        <modify-name-screening-hit></modify-name-screening-hit>
        <score-breakdown-popup
            @close="() => removeScoreBreakdown()"
            :data="scoreObject"
            :hitScore="hitScore"
            :keywords="hitKeywords"
            :isAdverseMediaHit="isAdverseMediaHit"
        ></score-breakdown-popup>
    </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import customerInformation from '@/components/CustomerInfo.vue'
import kycStatusReviewPopup from '@/components/popups/KYCStatusReviewPopup.vue'
import cancelReviewProcessPopup from '@/components/popups/CancelReviewProcessPopup.vue'
import screeningDetailPopup from '@/components/popups/ScreeningDetailPopup.vue'
import statusTypeIcon from '@/components/AlertType.vue'
import manualAlertPopup from '@/components/popups/ManualAlertPopup.vue'
import OtpVerificationPopup from '@/components/popups/OtpVerificationPopup.vue'
import modifyNameScreeningHit from '@/components/popups/ModifyNameScreeningHit.vue'
import scoreBreakdownPopup from '../../../components/popups/ScoreBreakdownPopup.vue'
import NotFound from '@/views/404/NotFound.vue'
import request from '@/utils/request'
import resource from '@/api/resource'
import _ from 'lodash'
var resourceApi = new resource('customers/name-screening')
let resourceApiFetchPdf = new resource('customers/generateReport')
import axios from 'axios'

export default {
    components: {
        customerInformation,
        kycStatusReviewPopup,
        cancelReviewProcessPopup,
        screeningDetailPopup,
        statusTypeIcon,
        manualAlertPopup,
        OtpVerificationPopup,
        NotFound,
        modifyNameScreeningHit,
        scoreBreakdownPopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        id: {
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            screeningInfo: {},
            showPageLoader: true,
            customerDetails: {},
            fields: [],
            updatedDetails: [],
            loading: false,
            loadingSummaryPdf: false,
            yesUpdate: false,
            canReturnAlert: '',
            isActive: false,
            markHits: 'false',
            markStatus: false,
            hideInactiveHits: false,
            scoreObject: {},
            hitKeywords: [],
            isAdverseMediaHit: false,
            hitScore: 0,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'profile',
            'dataSegmentId',
            'customerRecord',
            'kycRole',
            'alertRecord',
        ]),

        /**
         *
         * @return {array}
         */
        items() {
            this.updatedDetails = this.customerDetails.nameScreeningHits
                ? this.customerDetails.nameScreeningHits
                : []
            // console.log(
            //     'this.customerDetails.nameScreeningHits',
            //     this.customerDetails.nameScreeningHits
            // )
            // return this.customerDetails.nameScreeningHits
            //     ? this.customerDetails.nameScreeningHits
            //     : []

            function filterNameScreeningHits(item) {
                return item.screeningData.listStatus
            }

            return this.customerDetails.nameScreeningHits
                ? this.hideInactiveHits
                    ? this.customerDetails.nameScreeningHits.filter(
                          filterNameScreeningHits
                      )
                    : this.customerDetails.nameScreeningHits
                : []
        }, // End of items() method

        /**
         *
         * @return {string}
         */
        searchUrl() {
            return `/google-search.html?q="${this.customerDetails.fullName}"+ corruption OR trafficking OR extortion OR crime OR intimidation`
        }, // End of searchUrl() method
        isBtnDisabled() {
            if (typeof localStorage.getItem('isLeastRole') == 'string') {
                if (localStorage.getItem('isLeastRole') == 'false') {
                    // console.log('typeof')
                    return true
                }
            }
            if (!this.items.length) {
                // console.log('items.length')
                return true
            }
            if (
                this.customerRecord.nameScreeningStatus == 'pending' ||
                this.customerRecord.nameScreeningStatus == 'completed' ||
                this.customerRecord.nameScreeningStatus == 'locked'
            ) {
                // console.log(
                //     'this.customerRecord.nameScreeningStatus ',
                //     this.customerRecord.nameScreeningStatus
                // )
                return true
            }
            return false
        },
    }, // End of Component > filters
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.$router.push({ name: 'view-customer-profile' })
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.initializeData()
        localStorage.setItem('goBackUrl', 'view-alerts')
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        getMatchedDob(screeningdata) {
            let oldDobs =
                screeningdata.dates && screeningdata.dates.length
                    ? screeningdata.dates
                    : []
            let newDobs =
                screeningdata.dob && screeningdata.dob.length
                    ? screeningdata.dob
                    : []
            let formatCustomerYob = this.$moment(
                this.customerDetails.dateOfBirth
            ).format('YYYY')

            let matchedDate = ''
            let unMatchedDate = ''
            if (oldDobs && oldDobs.length) {
                for (let i = 0; i < oldDobs.length; i++) {
                    const day = oldDobs[i].day
                    const month = oldDobs[i].month
                    const year = oldDobs[i].year

                    if (isNaN(day) || isNaN(month) || isNaN(year)) {
                        // console.log("Invalid date", oldDobs[i]);
                        matchedDate = ''
                    } else {
                        const unformattedDate = `${day}-${month}-${year}`

                        const formattedDate = this.$moment(
                            unformattedDate,
                            'DD-MM-YYYY'
                        ).format('YYYY')
                        if (formattedDate === formatCustomerYob) {
                            matchedDate =
                                this.sourceDobFormatting(unformattedDate)
                            // console.log("matched date old", matchedDate)
                        } else {
                            unMatchedDate =
                                this.sourceDobFormatting(unformattedDate)
                        }
                    }
                }
                return matchedDate
                    ? matchedDate
                    : unMatchedDate
                    ? unMatchedDate
                    : 'N/A'
            } else if (newDobs && newDobs.length) {
                for (let i = 0; i < newDobs.length; i++) {
                    const formattedDate = this.$moment(
                        newDobs[i].dob,
                        'DD/MM/YYYY'
                    ).format('YYYY')
                    // console.log("loop new dob",newDobs[i].dob)
                    if (formattedDate === formatCustomerYob) {
                        // matchedDate =  this.sourceDobFormatting(newDobs[i].dob)
                        matchedDate = this.$moment(
                            newDobs[i].dob,
                            'DD/MM/YYYY'
                        ).format('MMM D, YYYY')
                        // console.log("match FOUND from new dob", matchedDate)
                    } else {
                        // unMatchedDate = this.sourceDobFormatting(newDobs[i].dob)
                        unMatchedDate = this.$moment(
                            newDobs[i].dob,
                            'DD/MM/YYYY'
                        ).format('MMM D, YYYY')
                        // console.log("match not found from new dob")
                    }
                }
                return matchedDate
                    ? matchedDate
                    : unMatchedDate
                    ? unMatchedDate
                    : 'N/A'
            } else {
                return 'N/A'
            }
        },
        getMatchedIdNumber(idNumberArr) {
            let customerIdInfo = this.customerDetails.identityInfo
            let matchedId = []
            let matchedIdNo = []
            if (idNumberArr && idNumberArr.length && customerIdInfo.number) {
                //old id types
                if (Object.keys(idNumberArr[0]).includes('value')) {
                    // matchedId = this.getMatchingItems(customerIdInfo.type, idNumberArr, "type")
                    // if(matchedId && matchedId.length){
                    matchedIdNo = this.getMatchingItems(
                        customerIdInfo.number,
                        idNumberArr,
                        'value'
                    )
                    // console.log("old matched Id no",matchedIdNo )

                    // }
                    return matchedIdNo && matchedIdNo.length
                        ? matchedIdNo[0].value
                        : idNumberArr[0].value
                        ? idNumberArr[0].value
                        : 'N/A'

                    //new id types
                } else if (Object.keys(idNumberArr[0]).includes('id_number')) {
                    // matchedId = this.getMatchingItems(customerIdInfo.type, idNumberArr, "id_type")
                    // if(matchedId && matchedId.length){
                    matchedIdNo = this.getMatchingItems(
                        customerIdInfo.number,
                        idNumberArr,
                        'id_number'
                    )
                    //  console.log("new matched Id no",matchedIdNo )

                    // }
                    return matchedIdNo && matchedIdNo.length
                        ? matchedIdNo[0].id_number
                        : idNumberArr[0].id_number
                        ? idNumberArr[0].id_number
                        : 'N/A'
                } else {
                    return 'N/A'
                }
            } else {
                return 'N/A'
            }
        },
        getMatchedCountry(screeningdata) {
            let oldCountry =
                screeningdata.country && screeningdata.country.length
                    ? screeningdata.country
                    : []
            let newCountry =
                screeningdata.nationality && screeningdata.nationality.length
                    ? screeningdata.nationality
                    : []
            let customerCountry = this.customerDetails.basicInfo.nationality
                ? this.customerDetails.basicInfo.nationality
                : ''
            // console.log("old country", oldCountry)
            // console.log("new country", newCountry)
            // console.log("customer country", customerCountry)

            let matchedCountry = []
            if (oldCountry && oldCountry.length) {
                for (const country of oldCountry) {
                    if (country.type === 'Citizenship') {
                        return country.name && customerCountry == country.name
                            ? country.name
                            : country.name
                            ? country.name
                            : 'N/A'
                    }
                }
            } else if (newCountry && newCountry.length) {
                matchedCountry = this.getMatchingItems(
                    customerCountry,
                    newCountry,
                    'nationality'
                )
                // console.log("matched nationality new ", matchedCountry)
                return matchedCountry && matchedCountry.length
                    ? matchedCountry[0].nationality
                    : newCountry && newCountry.length
                    ? newCountry[0].nationality
                    : 'N/A'
            } else {
                return 'N/A'
            }
        },
        getSourceName(screeningdata){
            return screeningdata.metadata && screeningdata.metadata.list_name ? screeningdata.metadata.list_name 
                : screeningdata.sourceList ? screeningdata.sourceList : 'N/A'
        },
        getPublisherName(screeningdata){
            if(screeningdata.sourceList == 'Smart Search') {
                return 'Idenfo';
            }
            return screeningdata.metadata && screeningdata.metadata.publisher_name ? screeningdata.metadata.publisher_name 
                : screeningdata.sourceList ? screeningdata.sourceList : 'N/A'
        },
        getMatchingItems(inputValue, dataArray, key) {
            const matchingItems = dataArray.filter((item) =>
                item[key]
                    ? item[key].trim().toLowerCase() ===
                      inputValue.trim().toLowerCase()
                    : false
            )

            return matchingItems
        },
        checkNameType(name) {
            if (typeof name == 'string') {
                return name
            } else if (typeof name == 'object' && Array.isArray(name)) {
                return name[0].firstName
            } else {
                return 'N/A'
            }
        },
        toggleHideInactiveHits() {
            this.hideInactiveHits = !this.hideInactiveHits
            console.log(this.hideInactiveHits)
        },
        async toggleAllHitsAsNotGenuine(status, event) {
            this.updatedDetails.forEach((each) => {
                console.log(each)
                if (event == 'true') {
                    each.hitDetermination = ''
                } else {
                    each.hitDetermination = 'pending'
                }
            })
        },
        tipMethod() {
            return `<strong>Sanction</strong>: a hit from any key global sanction list<br>
                    <strong>Special Interest</strong>: a hit from any key global enforcement list or a hit from a public search checking for financial crime<br>
                    <strong>PEP</strong>: a hit from any key global PEP list or a hit from a public search checking for politicians and their relatives or close associates`
        },
        /**
         *
         * @return {void}
         */
        async initializeData() {
            this.fields = this.profile.screenCustomer.fields
            console.log(
                'this.profile.screenCustomer.fields',
                this.profile.screenCustomer
            )

            try {
                let { data } = await request({
                    url: `customers/name-screening/${this.id}`,
                })
                console.log('data ', data)
                this.customerDetails = data.data
            } catch (error) {
                console.log(error)
            }
            this.showPageLoader = false
        }, // End of initializeData() method

        sourceDobFormatting(date) {
            if (date === '' || !date) {
                return 'N/A'
            }
            return this.$moment(date).format('MMM D, YYYY')
        },
        descriptionFormatting(descriptArray) {
            let data = []
            if (
                this.descriptArray &&
                this.descriptArray.description1 &&
                this.descriptArray.description1.length
            ) {
                data = [...data, ...this.descriptArray.description1]
            }
            if (
                this.descriptArray &&
                this.descriptArray.description2 &&
                this.descriptArray.description2.length
            ) {
                data = [...data, ...this.descriptArray.description2]
            }
            if (
                this.descriptArray &&
                this.descriptArray.description3 &&
                this.descriptArray.description3.length
            ) {
                data = [...data, ...this.descriptArray.description3]
            }
            let result = ''
            data.forEach((element) => {
                if (element.type == 'Snippet') {
                    result += ' ' + element.value
                }
                if (element.type == 'Link') {
                    result += ' ' + element.value
                }
            })

            return result == '' ? 'N/A' : result
        },
        selectedRecord(record, index) {
            record.index = index
            console.log('record ', record)
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        async updatedNameScreeningDetails() {
            let check = this.updatedDetails.find(
                (o) => o.hitDetermination === 'pending'
            )
            if (!check) {
                this.$store.commit('setLoading', true)
                this.loading = true
                try {
                    await resourceApi.update(this.$route.params.id, {
                        detail: this.updatedDetails,
                        alertId: this.alertRecord._id,
                    })
                    this.$store.commit(
                        'setSuccess',
                        'Name screening hits updated successfully'
                    )
                    let customerData = JSON.parse(
                        JSON.stringify(this.customerRecord)
                    )
                    let alert = JSON.parse(JSON.stringify(this.alertRecord))
                    alert.canCancelReview = false
                    alert.canReview = true
                    this.$store.commit('setAlertRecord', alert)
                    this.$store.commit('setCustomerRecord', customerData)
                } catch (error) {
                    this.$store.commit('setError', error)
                }
                this.$store.commit('setLoading', false)
                this.loading = false
            } else {
                this.$store.commit(
                    'setError',
                    'Please modify all name screening hits'
                )
            }
        },

        //        startDownload() {
        //            console.log('This is my current customer',this.customerDetails)
        //            console.log('This is my current customer id:',this.customerDetails._id)
        // this.$store.commit('setLoading', true)
        //            this.loadingSummaryPdf = true
        //            axios({
        //                method: 'get',
        //                url: `${process.env.VUE_APP_API_URL}customers/generateReport/${this.customerDetails._id}`,
        //                responseType: 'blob',
        //            })
        //                .then((response) => {
        //                    this.forceFileDownload(response)
        //                })
        //                .catch(() => console.log('error occured'))
        //        },

        startDownload() {
            console.log('This is my current customer', this.customerDetails)
            console.log(
                'This is my current customer id:',
                this.customerDetails._id
            )
            // this.$store.commit('setLoading', true)
            this.loadingSummaryPdf = true
            axios({
                method: 'get',
                url: `${process.env.VUE_APP_API_URL}customers/generateReport/${this.customerDetails._id}`,
            })
                .then((response) => {
                    console.log(
                        'hello I am repsonse:',
                        response.data.data.fileName
                    )
                    axios({
                        method: 'get',
                        url: `${process.env.VUE_APP_API_URL}files/reports-individual/${response.data.data.fileName}`,
                        responseType: 'blob',
                    }).then((response) => {
                        this.forceFileDownload(response)
                    })
                })
                .catch(() => console.log('error occured'))
        },

        forceFileDownload(response) {
            console.log('This is the response:', response)
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'download',
                `summary-report-${this.customerDetails.idenfoId}.pdf`
            )
            document.body.appendChild(link)
            link.click()
            // this.$store.commit('setLoading', false)
            this.loadingSummaryPdf = false
        },

        async updateNameScreeningHits(value, id) {
            if (value == 'hit') {
                _.filter(this.updatedDetails, function (o) {
                    if (id != o._id) {
                        o.hitDetermination = '' //empty hitDetermination corresponds to not genuine and hitDetermination = 'hit' corresponds to hitDetermination
                        return o
                    }
                })
            }
        },
        showScoreBreakDown(data) {
            console.log('ns :', data)
            if (data && data.scoreObject) {
                this.scoreObject = this.removeDash(data.scoreObject);
                this.hitKeywords = data.screeningData.keyword
                this.hitScore = data.score
                this.isAdverseMediaHit =
                    data.screeningData.sourceList == 'Smart Search'
                this.$bvModal.show('score-breakdown-popup')
            }
        },
        removeDash(obj){
            let newObj = {};
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    // Replace dashes with periods in keys
                    let newKey = key.replace(/_/g, '.');
                    // Check if the value is a string and replace dashes with periods
                    let value = obj[key];
                    if (typeof value === 'string') {
                        value = value.replace(/_/g, '.');
                    }
                    newObj[newKey] = value;
                }
            }
            console.log("new obj,", newObj)
            return newObj;
        },
        removeScoreBreakdown() {
            this.scoreObject = {}
            this.hitScore = 0
            this.hitKeywords = []
            this.isAdverseMediaHit = false
        },
        objectIsEmpty(obj) {
            if (!obj) return true
            if (typeof obj == 'object' && Object.keys(obj).length == 0)
                return true
            if (obj == '') return true

            return false
        },
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > filters
    |--------------------------------------------------------------------------
    */
    filters: {
        simpleReturn: function (value) {
            if (!value) return 'N/A'
            if (value === '') return 'N/A'

            return value.toString()
        },
        primaryName: function (value) {
            if (!value) return ''
            value = value.filter((v) => {
                return v.type === 'Primary Name'
            })

            return value[0].firstName
        },
        citizenship: function (value) {
            if (value) {
                let citizenship = value.filter((v) => {
                    return v.type === 'Citizenship'
                })
                if (citizenship && citizenship[0] && citizenship[0].name) {
                    return citizenship[0].name
                }
            }
            return ''
        },
        fathersName: function (value) {
            if (!value) return ''
            value = value.filter((v) => {
                return v.type === 'Primary Name'
            })

            return value[0].lastName
        },
    }, // End of Component > watch
} // End of export default
</script>

<style scoped>
.scoreBreakdownLink {
    color: #662d91;
    text-decoration: underline;
    cursor: pointer;
}
</style>
